<template>
  <div>
    <p>
      <span class="modal-body-text"
        >Are you sure you want to delete this consent?</span
      >
      <br />
    </p>
  </div>
</template>

<script>
export default {
  props: {
    data: null
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal/DeleteConsent.vue